module.exports = __webpack_public_path__ + "static/media/logo-zedoca.035b9b7a.png";